import React, { useEffect, useState } from "react";
import { m } from "framer-motion";
import { Instagram, ExternalLink } from "lucide-react";
import { api } from "../lib/api";

function TikTokIcon({ size = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.85a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.28z" />
    </svg>
  );
}

export default function InstagramFeed() {
  const [items, setItems] = useState([]);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems((r.data || []).slice(0, 6))).catch(() => {});
    api.get("/contact-info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const igUrl = info?.instagram || "";
  const ttUrl = info?.tiktok || "";

  // Sezione visibile solo con foto in galleria E un profilo Instagram impostato dal pannello
  if (!items.length || !igUrl) return null;

  return (
    <section data-testid="instagram-feed" className="py-28 lg:py-36 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="gold-divider">
            <span className="font-display-sc text-[10px] tracking-[0.4em] text-[#C9A961]">Social</span>
          </div>
          <h2 className="font-display text-5xl md:text-6xl mt-8">
            Seguici su <span className="hero-script text-[#C9A961]">Instagram</span>
          </h2>
          <p className="font-elegant text-lg text-white/65 italic mt-6 max-w-xl mx-auto">
            Look, backstage e ispirazioni dal nostro salone di Palazzolo Acreide.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {items.map((g, i) => (
            <m.a
              key={g.id || i}
              href={igUrl}
              target="_blank"
              rel="noreferrer"
              data-testid={`ig-tile-${i}`}
              initial={{ opacity: 0.6, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: i * 0.05, duration: 0.45 }}
              className="group relative aspect-square overflow-hidden border border-[#1f1f1f] hover:border-[#C9A961] transition-colors"
            >
              <img
                src={g.image}
                alt={g.caption || "Polverini Hair System Instagram"}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/55 transition flex items-center justify-center opacity-0 group-hover:opacity-100">
                <Instagram className="text-white" size={26} />
              </div>
            </m.a>
          ))}
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={igUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="ig-follow-btn"
            className="inline-flex items-center justify-center gap-3 bg-[#C9A961] hover:bg-[#E0C087] text-[#0a0a0a] px-9 py-4 text-[11px] uppercase tracking-[0.32em] font-semibold transition"
          >
            <Instagram size={16} /> Segui su Instagram
          </a>
          <a
            href={ttUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="tiktok-follow-btn"
            className="inline-flex items-center justify-center gap-3 border-2 border-[#C9A961]/60 hover:border-[#C9A961] hover:bg-[#C9A961]/10 text-white px-9 py-4 text-[11px] uppercase tracking-[0.32em] font-semibold transition"
          >
            <TikTokIcon size={16} /> Seguici su TikTok
          </a>
        </div>
      </div>
    </section>
  );
}
